
import { computed, defineComponent, onMounted } from "vue";

import {
  ColumnDefinition,
  useDataTable,
  DataTable,
  DeleteIcon,
  EditIcon,
  CountButton,
  BaseButton,
} from "@tager/admin-ui";
import { useResourceDelete } from "@tager/admin-services";
import { Page } from "@tager/admin-layout";

import { deleteProductType, getProductTypeList } from "@/services/requests";
import { ProductTypeType } from "@/typings/model";
import {
  getFieldListUrl,
  getProductListUrl,
  getProductTypeFormUrl,
} from "@/utils/paths";

const COLUMN_DEFS: Array<ColumnDefinition<ProductTypeType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
  },
  {
    id: 3,
    name: "Системное имя",
    field: "systemName",
  },
  {
    id: 4,
    name: "Категория по-умолчанию",
    field: "defaultCategory",
    type: "string",
    format: ({ row }) => (row.defaultCategory ? row.defaultCategory.name : ""),
  },
  {
    id: 5,
    name: "",
    field: "other",
    style: { width: "200px", whiteSpace: "nowrap" },
    headStyle: { width: "200px" },
  },
  {
    id: 6,
    name: "Действия",
    field: "actions",
    style: { width: "101px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "101px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "ProductTypeList",
  components: {
    Page,
    DataTable,
    DeleteIcon,
    EditIcon,
    CountButton,
    BaseButton,
  },
  setup() {
    const {
      isLoading: isProductTypeListLoading,
      rowData: productTypeList,
      errorMessage,
      searchQuery,
      handleChange,
      fetchEntityList: fetchProductTypeList,
    } = useDataTable<ProductTypeType>({
      fetchEntityList: (params) =>
        getProductTypeList({ query: params.searchQuery }),
      initialValue: [],
      resourceName: "Product type list",
    });

    onMounted(() => {
      fetchProductTypeList();
    });

    const { handleResourceDelete: handleProductTypeDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteProductType,
        resourceName: "ProductType",
        onSuccess: fetchProductTypeList,
      });

    const isRowDataLoading = computed<boolean>(
      () => isProductTypeListLoading.value
    );

    function isBusy(productTypeId: number): boolean {
      return isDeleting(productTypeId) || isRowDataLoading.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: productTypeList,
      isRowDataLoading,
      errorMessage,
      searchQuery,
      handleChange,

      isBusy,
      handleProductTypeDelete,
      getProductTypeFormUrl,
      getFieldListUrl,
      getProductListUrl,
    };
  },
});
